<h2 [innerHtml]="heading"></h2>
<div style="margin-top:10px">
    <p [innerHtml]="paragraph1"></p>
    <p [innerHtml]="paragraph2"></p>  
    <p [innerHtml]="paragraph3"></p>    
</div>